import { TransitControlFilter } from '../models';

export const TRANSIT_CONTROL_MAX_DATE_RANGE_DAYS = 20;

const MS_PER_DAY = 86400000;

export function getTransitControlExportValidationMessage(
  filter: TransitControlFilter
): string | null {
  if (!filter.originStatusId) {
    return 'Debe seleccionar el estado origen.';
  }
  if (!filter.destinationStatusId) {
    return 'Debe seleccionar el estado destino esperado.';
  }
  if (filter.originStatusId === filter.destinationStatusId) {
    return 'El estado origen y el estado destino esperado no pueden ser iguales.';
  }
  if (!filter.dateFrom || !filter.dateTo) {
    return 'Debe indicar el rango de fechas (desde y hasta).';
  }
  if (filter.dateFrom.getTime() > filter.dateTo.getTime()) {
    return 'La fecha desde debe ser anterior o igual a la fecha hasta.';
  }
  const spanMs = filter.dateTo.getTime() - filter.dateFrom.getTime();
  if (spanMs > TRANSIT_CONTROL_MAX_DATE_RANGE_DAYS * MS_PER_DAY) {
    return `El rango de fechas no puede superar ${TRANSIT_CONTROL_MAX_DATE_RANGE_DAYS} días.`;
  }

  return null;
}

export function buildTransitControlExportBody(
  filter: TransitControlFilter
): Record<string, string | string[]> {
  const body: Record<string, string | string[]> = {
    originStatusId: filter.originStatusId,
    destinationStatusId: filter.destinationStatusId,
    dateFrom: filter.dateFrom!.toISOString(),
    dateTo: filter.dateTo!.toISOString(),
  };

  if (filter.commerceId) {
    body.commerceId = filter.commerceId;
  }
  if (filter.logisticOperatorId) {
    body.logisticOperatorId = filter.logisticOperatorId;
  }
  if (filter.serviceWithOperatorIds?.length) {
    body.serviceWithOperatorIds = filter.serviceWithOperatorIds;
  }

  return body;
}
